import useLocalStorage from "./useLocalStorage";

const useFileDownloader = () => {
  const storage = useLocalStorage();

  return {
    download: (url, payload) => {
      let filename = "";
      const options = {
        method: "POST",
        headers: {
          Authorization: `Bearer ${storage.getAccessToken()}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      };

      return fetch(`${process.env.REACT_APP_BASE_URL}${url}`, options)
        .then((res) => {
          filename = res.headers
            .get("Content-Disposition")
            .split("filename=")[1];
          return res.blob();
        })
        .then((blob) => {
          const href = URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = href;
          link.setAttribute("download", filename);
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          URL.revokeObjectURL(href);
        });
    },
  };
};

export default useFileDownloader;
